import { Component, OnDestroy, AfterViewInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'flowaccount-digital-accounting-conference',
  templateUrl: './digital-accounting-conference.component.html',
})
export class DigitalAccountingConferenceComponent implements OnDestroy, AfterViewInit {
  private langChangeSubscription?: Subscription
  constructor(
    private readonly seoService: SEOService,
    private readonly titleService: Title,
    public translate: TranslateService,
  ) {
    this.setMeta()
    this.langChangeSubscription = translate.onLangChange.subscribe(() => {
      this.setMeta()
    })
  }

  ngAfterViewInit(): void {
    this.checkQrCookieAndRedirect()
  }

  setMeta() {
    const metaTitle = this.translate.instant('EVENT.DIGITAL_ACCOUNTING_CONFERENCE.SEO_META.TITLE')
    const metaDescription = this.translate.instant('EVENT.DIGITAL_ACCOUNTING_CONFERENCE.SEO_META.DESCRIPTION')
    const imageUrl = 'https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/og_Image.png'

    this.titleService.setTitle(metaTitle)
    this.seoService.createMetaTag(metaTitle, metaDescription)
    this.seoService.createOg(imageUrl, metaTitle, metaDescription)
    this.seoService.setRobotsByLanguage(this.translate.currentLang)
  }
  ngOnDestroy() {
    this.langChangeSubscription?.unsubscribe()
  }

  private checkQrCookieAndRedirect(): void {
    const cookies = document.cookie
    const shouldRedirect = cookies.includes('redirectToDAC25Form=true')

    if (!shouldRedirect) return

    window['dataLayer'] = window['dataLayer'] || []
    window['dataLayer'].push({
      event: 'DAC2025_feedback',
    })

    document.cookie = 'redirectToDAC25Form=; max-age=0; path=/'

    const forms =
      'https://docs.google.com/forms/d/e/1FAIpQLSelW3Z_XdfYaKNZqcbdG9hY85-xW83TwHpdaQuU8QkXjU-3oA/viewform?usp=dialog'

    setTimeout(() => {
      window.location.href = forms
    }, 500)
  }
}
